/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: TerritoriesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: TerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { TerritoriesData, TerritoriesService }  from './Territories.service';

import { RegionData, RegionService } from '../Region/Region.service';


@Component({
  template: require('./TerritoriesEdit.component.html'),
  providers: [TerritoriesService
	, RegionService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class TerritoriesEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objTerritories: TerritoriesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	RegionList: RegionData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private TerritoriesService: TerritoriesService
			, private  RegionService:  RegionService

	) {
		// this.id = parseInt(params.get('id'));
		this.objTerritories = new TerritoriesData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.TerritoriesService.getByID(+params['id']))
		.switchMap((params: Params) => this.TerritoriesService.getByID(params['id']))
		.subscribe((item: TerritoriesData) => this.objTerritories = item);
		this.getLookups();
	}

	updateTerritories() {
		this.TerritoriesService.updateTerritoriesData(this.objTerritories)
			.subscribe(record => this.router.navigate(['/Territories']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Territories record updated successfully...', 'Edit Territories');
					console.log('Territories record updated successfully...'); 
				}
			);
	}
  
	deleteTerritories(id: string) {
		if (window.confirm('Are you sure you want to delete this Territories?') == true) 
		{
			this.TerritoriesService.deleteTerritories(this.objTerritories.TerritoryID.toString())
			.subscribe(record => this.router.navigate(['/Territories']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Territories record deleted successfully...', 'Delete Territories');
					console.log('Territories record deleted successfully...'); 
				}
			);
		}
	}

	gotoTerritories() {
		let Id = this.objTerritories ? this.objTerritories.TerritoryID : null;
		this.router.navigate(['/Territories']);
	}

	// Get Lookup List for Region
    getRegion() {
		this.RegionService.getAll().subscribe(records => this.RegionList=records);
    }

	getLookups() {

        this.getRegion();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Territories/TerritoriesEdit.component.ts